import type { FC } from 'react';

import type { SkeletonRowProps } from 'Components/Account/utilities/VehicleListStateHandler/VehicleListStateHandler';
import { DatagridCell, DatagridRow } from 'Storybook/core/Datagrid';
import Skeleton from 'Storybook/core/Skeleton/Skeleton';
import SkeletonVehicleData from 'Storybook/peripheral/VehicleData/SkeletonVehicleData/SkeletonVehicleData';

import styles from '../PurchasesVehicleList.module.scss';

const PurchasesLoadingSkeltonRow: FC<SkeletonRowProps> = ({ id, index }) => {
	return (
		<DatagridRow key={id} gridClass={styles.datagridCustom} id={id.toString()} index={index} isInteractive={false}>
			<DatagridCell index={0} rowIndex={index}>
				<SkeletonVehicleData />
			</DatagridCell>
			<DatagridCell index={1} rowIndex={index}>
				<div className={styles.textContainer}>
					<Skeleton width={20} />
				</div>
			</DatagridCell>
			<DatagridCell index={2} rowIndex={index}>
				<div className={styles.textContainer}>
					<Skeleton width={9} />
				</div>
			</DatagridCell>
			<DatagridCell index={3} rowIndex={index}>
				<div className={styles.textContainer}>
					<Skeleton width={11} />
				</div>
			</DatagridCell>
			<DatagridCell index={4} rowIndex={index}>
				<div className={styles.textContainer}>
					<Skeleton height={3} width={3} />
				</div>
			</DatagridCell>
		</DatagridRow>
	);
};

export { PurchasesLoadingSkeltonRow };
